class SportwristxAboutCarousel extends HTMLElement {
  connectedCallback() {
    if (this.dataset.aboutBound) return;
    this.dataset.aboutBound = 'true';
    this.rail = this.querySelector('[data-about-rail]');
    this.previous = this.querySelector('[data-about-previous]');
    this.next = this.querySelector('[data-about-next]');
    this.controls = this.querySelector('[data-about-controls]');
    if (!this.rail || !this.previous || !this.next) return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.rail.addEventListener('scroll', () => this.update(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.rail);
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  move(direction) {
    const card = this.rail.querySelector('.swx-about__stage');
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
    this.rail.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
    });
  }

  update() {
    const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    const hasOverflow = max > 2;
    this.controls.hidden = !hasOverflow;
    this.previous.disabled = !hasOverflow || this.rail.scrollLeft <= 2;
    this.next.disabled = !hasOverflow || this.rail.scrollLeft >= max - 2;
  }
}

if (!customElements.get('sportwristx-about-carousel')) {
  customElements.define('sportwristx-about-carousel', SportwristxAboutCarousel);
}

class SportwristxFaqBrowser extends HTMLElement {
  connectedCallback() {
    if (this.dataset.faqBound) return;
    this.dataset.faqBound = 'true';
    this.search = this.querySelector('[data-faq-search]');
    this.categoryButtons = [...this.querySelectorAll('[data-faq-category]')];
    this.items = [...this.querySelectorAll('[data-faq-item]')];
    this.empty = this.querySelector('[data-faq-empty]');
    this.activeCategory = 'all';

    this.search?.addEventListener('input', () => this.filter());
    this.categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.faqCategory;
        this.categoryButtons.forEach((candidate) => {
          candidate.setAttribute('aria-selected', String(candidate === button));
        });
        this.filter();
      });
    });
  }

  filter() {
    const query = this.search?.value.trim().toLocaleLowerCase() || '';
    let visible = 0;
    this.items.forEach((item) => {
      const categoryMatches = this.activeCategory === 'all' || item.dataset.faqItemCategory === this.activeCategory;
      const queryMatches = !query || item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !(categoryMatches && queryMatches);
      if (!item.hidden) visible += 1;
    });
    if (this.empty) this.empty.hidden = visible !== 0;
  }
}

if (!customElements.get('sportwristx-faq-browser')) {
  customElements.define('sportwristx-faq-browser', SportwristxFaqBrowser);
}
